/**
 * Workspace URLs name the organization: /college/<slug>/students,
 * /company/<slug>/jobs. These are the first path segments of the pages in each
 * workspace, so the web app can tell "/college/students" (no organization
 * named) from "/college/<slug>". An organization can't take one as its slug.
 */
export const ORG_URL_SECTIONS = {
    college: [
        'dashboard',
        'setup',
        'students',
        'staff',
        'structure',
        'records',
        'skill-insights',
        'drives',
        'companies',
        'opt-outs',
        'notices',
        'assessments',
        'messages',
        'analytics',
        'documents',
        'billing',
        'checkout',
        'settings',
    ],
    company: [
        'dashboard',
        'jobs',
        'candidates',
        'assessments',
        'interviews',
        'messages',
        'organization',
        'analytics',
        'branding',
        'documents',
        'pipeline',
        'billing',
        'checkout',
        'settings',
    ],
};
export const RESERVED_ORG_SLUGS = Array.from(new Set([...ORG_URL_SECTIONS.college, ...ORG_URL_SECTIONS.company]));
